/*
 * Copyright (c) 2025-2026 Aegis AO Soft LLC and Alexander Orlov.
 * Confidential and proprietary. Author: Alexander Orlov.
 *
 * Shared title hero for the storefront's standalone pages (About / Terms / Contact).
 * Uses the tenant's banner image if set, else the page background image (Design editor),
 * else a dark fallback — always with a dark overlay so the white title stays legible.
 */

import { useTenant } from '../contexts/TenantContext';

export default function PageHero({ title, subtitle }: { title: string; subtitle?: string }) {
  const { tenant } = useTenant();
  const banner = tenant?.bannerImageUrl;
  const hasImage = !!(banner || tenant?.backgroundImageUrl);

  return (
    <section
      className={`relative w-full h-56 md:h-72 lg:h-80 ${hasImage ? '' : 'bg-zinc-900'}`}
      style={
        banner
          ? { backgroundImage: `url(${banner})`, backgroundSize: 'cover', backgroundPosition: 'center' }
          : {}
      }
    >
      {/* Darken banner / page-background image for legible title text. */}
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white drop-shadow-2xl">{title}</h1>
        {subtitle && <p className="mt-3 text-lg md:text-xl text-gray-200 max-w-2xl">{subtitle}</p>}
      </div>
    </section>
  );
}
